export default {
  login: 'login',
  termsAndConditions: 'termsAndConditions',

  // Projects
  projectsDashboard: 'projects.dashboard',
}